'use strict';exports.__esModule = true;var _isObject = require('lodash/isObject');var _isObject2 = _interopRequireDefault(_isObject);
var _isEmpty = require('lodash/isEmpty');var _isEmpty2 = _interopRequireDefault(_isEmpty);
var _lodash = require('lodash');

var _parkingConverter = require('../../../utils/parkingConverter');var _parkingConverter2 = _interopRequireDefault(_parkingConverter);
var _formatSEOData = require('../../../utils/formatSEOData');
var _commodities = require('../../../helpers/commodities');
var _makeSharingUrl = require('../../../utils/makeSharingUrl');var _makeSharingUrl2 = _interopRequireDefault(_makeSharingUrl);
var _constants = require('../../../constants');function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}





var getArea = function getArea(areaObject, translate, isCottage) {
  var area = [];
  Object.keys(areaObject).forEach(function (value) {
    if (areaObject[value]) {
      var title = !isCottage && value === 'base' ? 'area' : value;
      area.push({
        type: 'area',
        value: areaObject[value],
        title: translate('propertyDetails', 'details', title),
        summaryTitle: translate('propertyDetails', 'details', 'summaryAreaTitle') });

    }
  });
  return area;
};

var getCompanyContactsName = function getCompanyContactsName(companyContactsName) {var locale = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'he';
  if (!companyContactsName) return undefined;

  if (typeof companyContactsName === 'string') {
    return companyContactsName;
  }

  return companyContactsName[locale] || companyContactsName.he;
};

// Some HELL CODE over here
var adapter = function adapter(_ref) {var translate = _ref.translate,locale = _ref.locale,enPropertyType = _ref.enPropertyType,descriptionData = _ref.descriptionData,propertyData = _ref.propertyData;var

  price =































  propertyData.price,currency = propertyData.currency,_propertyData$additio = propertyData.additional_info;_propertyData$additio = _propertyData$additio === undefined ? {} : _propertyData$additio;var rooms = _propertyData$additio.rooms,toilets = _propertyData$additio.toilets,parking = _propertyData$additio.parking,payments = _propertyData$additio.payments,areaObject = _propertyData$additio.area,floor = _propertyData$additio.floor,year = _propertyData$additio.construction_year,elevators = _propertyData$additio.elevators,balconies = _propertyData$additio.balconies,bathrooms = _propertyData$additio.bathrooms,entryDateObject = _propertyData$additio.entry_date,windDirection = _propertyData$additio.light_direction,hasBasement = _propertyData$additio.hasBasement,type = propertyData.property_type,description = propertyData.description,contacts = propertyData.contacts,_propertyData$company = propertyData.company_contacts,companyContactsData = _propertyData$company === undefined ? {} : _propertyData$company,commodities = propertyData.commodities,_propertyData$images = propertyData.images,images = _propertyData$images === undefined ? [] : _propertyData$images,thumbnail = propertyData.thumbnail,address = propertyData.address,hasPhotos = propertyData.has_photos,isActive = propertyData.is_active,isSuspended = propertyData.is_suspended,realtorProperty = propertyData.realtor_property,shouldRemovePropertyRealtorIcon = propertyData.should_remove_property_realtor_icon,agencyId = propertyData.agency_id,searchOption = propertyData.search_option;

  var id = (0, _lodash.get)(propertyData, 'id', 'regfweresr');

  var isCottage = enPropertyType === 'cottage';
  var isVilla = enPropertyType === 'villa';
  var isLand = enPropertyType === 'land';
  var entryDate = entryDateObject && entryDateObject instanceof Date ?
  entryDateObject :
  (entryDateObject || {}).date; // for migrating purposes

  var shouldRenderDate = entryDateObject && Object.values(entryDateObject).filter(function (field) {return !!field;}).length;

  var englishAddressRequired = _constants.localesWithEnglishAddress.includes(locale);
  var localisedAddress = englishAddressRequired ?
  address.en :
  address[locale] || address[_constants.language.default];
  var sharingTitle = (0, _formatSEOData.formatPropertyTitle)(Object.assign({},
  propertyData, { isLand: isLand }),
  propertyData.property_type,
  translate('propertyDetails'),
  locale);

  var neighborhood = localisedAddress.city_name === localisedAddress.neighborhood ? '' : localisedAddress.neighborhood;
  var sharingUrl = (0, _makeSharingUrl2.default)('/home_details/' + id, locale);
  var SEODescription = (0, _formatSEOData.formatPropertyDescription)(Object.assign({}, propertyData, { isLand: isLand }), translate('propertyDetails', 'SEODescription'));
  var isGroundFloor = floor && floor.on_the === 0;
  var floorOn = isGroundFloor ? translate('propertyDetails', 'details', 'groundFloor') : floor && floor.on_the;
  var floorOf = floor && floor.out_of || '';
  var areaValue = (0, _isObject2.default)(areaObject) ? areaObject.base : areaObject; // for migration purposes
  var pricePerSqMeter = Math.round(price / (areaValue || 1));

  var floorField = isCottage || isVilla ?
  { title: translate('propertyDetails', 'details', 'floors'), value: '' + floorOn, type: 'floor' } :
  {
    title: translate('propertyDetails', 'details', 'floor'),
    value: floorOn + ' ' + translate('propertyDetails', 'details', 'outOf') + ' ' + floorOf,
    type: 'floor' };


  var windDirectionValues = windDirection &&
  Object.keys(windDirection).filter(function (side) {return windDirection[side] === true;});

  var translatedDirectionsData = windDirectionValues && windDirectionValues.length ?
  {
    title: translate('propertyDetails', 'details', 'directionOfTheWind'),
    value: windDirectionValues.map(function (direction) {return translate('propertyDetails', 'details', 'compass', direction);}).join(', ') } :

  {};

  var aboutProperty = [
  { title: translate('propertyDetails', 'propertyType', 'title'), value: type, type: 'propertyType' },
  isLand ? {} : { title: translate('propertyDetails', 'details', 'rooms'), value: rooms, type: 'rooms' },
  isLand ? {} : floorField,
  isLand ? {} : { title: translate('propertyDetails', 'details', 'parkingSpots'), value: (0, _parkingConverter2.default)(parking), type: 'parkingSpots' },
  translatedDirectionsData].concat(
  getArea(areaObject, translate, isCottage || isVilla), [
  { title: translate('propertyDetails', 'details', 'bath'), value: bathrooms, type: 'bath' },
  { title: translate('propertyDetails', 'details', 'toilets'), value: toilets, type: 'toilets' },
  { title: translate('propertyDetails', 'details', 'balcony'), value: balconies, type: 'balcony' }]);


  var aboutPropertyAdditionals = (0, _commodities.mapPropertyCommodities)(commodities);
  if (hasBasement) {
    aboutPropertyAdditionals.push('basement');
  }

  var aboutBuilding = [
  { title: translate('propertyDetails', 'details', 'constructionYear'), value: year, type: 'constructionYear' },
  isLand ? {} : { title: translate('propertyDetails', 'details', 'elevator'), value: elevators, type: 'elevator' }];

  var aboutBuildingAdditionals = (0, _commodities.mapBuildingCommodities)(commodities);

  var translatedDirections = windDirectionValues && windDirectionValues.length ?
  windDirectionValues.map(function (direction) {return translate('propertyDetails', 'details', 'compass', direction);}) :
  [];

  var isAboutBuildingFull = isCottage || isVilla || isLand ?
  aboutBuilding.some(function (detail) {return !!detail.value && detail.value !== 0;}) :
  true;

  var contactsData = { propertyId: id, isActive: isActive, sharingUrl: sharingUrl, sharingTitle: sharingTitle, thumbnail: thumbnail };
  var desc = void 0;
  var showOriginalDescription = (0, _lodash.get)(descriptionData, 'showOriginalDescription');
  var translatedDescriptionRequired = (0, _lodash.get)(descriptionData, 'translatedDescriptionRequired');
  var descriptionLoaded = (0, _lodash.get)(descriptionData, 'descriptionLoaded');

  if (
  !translatedDescriptionRequired ||
  !showOriginalDescription ||
  !descriptionLoaded)
  {
    desc = description;
  } else if (
  translatedDescriptionRequired &&
  descriptionLoaded &&
  showOriginalDescription)
  {
    desc = descriptionData.translatedDescriptionText;
  }

  var companyContacts = !(0, _isEmpty2.default)(companyContactsData) ? Object.assign({},
  companyContactsData, {
    name: getCompanyContactsName(companyContactsData.name, locale) }) :
  {};

  return {
    address: address,
    hasPhotos: hasPhotos,
    contactsData: contactsData,
    desc: desc,
    price: price,
    currency: currency,
    pricePerSqMeter: pricePerSqMeter,
    contacts: contacts,
    realtorProperty: realtorProperty,
    shouldRemovePropertyRealtorIcon: shouldRemovePropertyRealtorIcon,
    type: type,
    searchOption: searchOption,
    isCottage: isCottage || isVilla,
    localisedAddress: localisedAddress,
    neighborhood: neighborhood,
    isGroundFloor: isGroundFloor,
    floorOn: floorOn,
    payments: payments,
    isSuspended: isSuspended,
    entryDate: entryDate,
    shouldRenderDate: shouldRenderDate,
    aboutBuildingAdditionals: aboutBuildingAdditionals,
    translatedDirections: translatedDirections,
    isAboutBuildingFull: isAboutBuildingFull,
    aboutProperty: aboutProperty,
    parking: parking,
    toilets: toilets,
    rooms: rooms,
    areaValue: areaValue,
    isActive: isActive,
    entryDateObject: entryDateObject,
    description: description,
    descriptionData: descriptionData,
    aboutPropertyAdditionals: aboutPropertyAdditionals,
    aboutBuilding: aboutBuilding,
    id: id,
    agencyId: agencyId,
    images: images,
    thumbnail: thumbnail,
    sharingTitle: sharingTitle,
    sharingUrl: sharingUrl,
    SEODescription: SEODescription,
    isLand: isLand,
    companyContacts: companyContacts };

};exports.default =

adapter;module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/PropertyDetailedInfo/PropertyDetails/adapter.js
// module id = 2826
// module chunks = 0